import { render, staticRenderFns } from "./UsageRules.vue?vue&type=template&id=e435ec08&scoped=true"
import script from "./UsageRules.vue?vue&type=script&setup=true&lang=js"
export * from "./UsageRules.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UsageRules.vue?vue&type=style&index=0&id=e435ec08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e435ec08",
  null
  
)

export default component.exports